import Vue from 'vue';
import '@/style/index.scss'; // global css
import 'amfe-flexible';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import store from './vuex';
import axios from "axios";
Vue.prototype.window = window;
Vue.use(ElementUI, {
    size: 'small'
  });
Vue.prototype.TITLE = process.env.TITLE;
Vue.prototype.$store = store;
Vue.prototype.$axios = axios;
import 'amfe-flexible'
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Videojs
// import { detectZoom } from '@/common/detectZoom';
// const m = detectZoom();
// document.body.style.zoom = 100 / Number(m);
export default new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.ts